export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15.26 9.494 6.855 4.64a.907.907 0 0 0-1.36.785v9.852a.906.906 0 0 0 1.36.784l8.407-4.854a.99.99 0 0 0 0-1.713"
                fill="#FFF"
                fillRule="evenodd"
            />
        </svg>
    );
}
